var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.165 15.551C0.351 15.831 0.664 16 1 16H16C16.4 16 16.762 15.762 16.919 15.394L19.919 8.394C19.9847 8.24194 20.0116 8.0759 19.9971 7.91087C19.9827 7.74584 19.9273 7.587 19.8362 7.44869C19.745 7.31038 19.6208 7.19694 19.4748 7.11861C19.3288 7.04028 19.1657 6.99951 19 7H18V4C18 2.897 17.103 2 16 2H9.345L6.789 0H2C0.897 0 0 0.897 0 2V15H0.00699997C0.00477108 15.1951 0.0596945 15.3867 0.165 15.551ZM16 4V7H4C3.6 7 3.238 7.238 3.081 7.606L2 10.129V4H16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.2c7b25a4a11e4b8a5621aa29d6548a69.svg";
export { ForwardRef as ReactComponent };